import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { IconSize } from '../IconWrap';
import FileIcon from '../24x24/File';
import GifIcon from '../24x24/AddGif';
import VideoIcon from '../24x24/AddVideo';
import s from './SmartAttachment.scss';
// A wrapper that receives a file type/extension (what we get from PAPI),
// tries to guess the file type and spits out a matching icon
const SmartAttachmentIcon = (_param)=>{
    var { type = '' } = _param, props = _object_without_properties(_param, [
        "type"
    ]);
    let Icon = FileIcon;
    if (type === 'gif') {
        Icon = GifIcon;
    } else if ([
        'jpg',
        'jpeg',
        'png',
        'bmp',
        'tiff'
    ].includes(type)) {
        return /*#__PURE__*/ React.createElement("div", {
            className: s['monalisa-wrapper']
        }, /*#__PURE__*/ React.createElement("div", {
            className: s['monalisa-icon']
        }));
    } else if ([
        'mp4',
        'mov',
        'avi',
        'wmv'
    ].includes(type)) {
        Icon = VideoIcon;
    }
    return /*#__PURE__*/ React.createElement(Icon, _object_spread({
        size: IconSize.SMALL
    }, props));
};
SmartAttachmentIcon.displayName = 'SmartAttachmentIcon';
export default SmartAttachmentIcon;
